module["exports"] = ["yandex.ru", "ya.ru", "mail.ru", "gmail.com", "yahoo.com", "hotmail.com"];